import React from "react";
import {Icon, Text, Flex} from "@chakra-ui/react";
import {MdCancel, MdCheckCircle, MdOutlineError} from "react-icons/md";

export default function InvoiceStatus(props) {

    const INVOICE_STATUS_PENDING = 'pending';
    const INVOICE_STATUS_PAID = 'paid';
    const INVOICE_STATUS_UNPAID = 'unpaid';

    const status = props.status;

    return (
        <Flex>
            <Icon
                w='24px'
                h='24px'
                me='5px'
                color={
                    status === INVOICE_STATUS_PAID
                        ? "green.500"
                        : status === INVOICE_STATUS_UNPAID
                            ? "red.500"
                            : status === INVOICE_STATUS_PENDING
                                ? "orange.500"
                                : null
                }
                as={
                    status === INVOICE_STATUS_PAID
                        ? MdCheckCircle
                        : status === INVOICE_STATUS_UNPAID
                            ? MdCancel
                            : status === INVOICE_STATUS_PENDING
                                ? MdOutlineError
                                : null
                }
            />
            <Text>{status === INVOICE_STATUS_PAID
                ? "Zahlung eingegangen"
                : status === INVOICE_STATUS_UNPAID
                    ? "Keine Zahlung"
                    : status === INVOICE_STATUS_PENDING
                        ? "Zahlung ausstehend"
                        : null}</Text>
        </Flex>
    );
}
